const GROWL = '[Notifications] Growl';
const SHOW_GROWL = '[Notifications] Show Growl';
const REMOVE_GROWL = '[Notifications] Remove Growl';
const SET_TIMEOUT = '[Notifications] Set Timeout';

export { GROWL, SHOW_GROWL, REMOVE_GROWL, SET_TIMEOUT };
